'use strict';

/**
 * Webduct Cookie Adapter (WebductCookieAdapter.js).
 * Webduct Cookie Adapter.
 *
 * @author rsweeney@webduct.com <rsweeney@webduct.com>
 * @author Erik Orozco <eorozco@intersog.com>
 * @copyright (c) 2018-2020 Build Centrix.
 *
 * @version
 * 1.15.0 LIBENV-53 Add WebductCookieAdapter into globalThis for ES6 usage
 * 1.0.0 LIBENV-1 Initialize environment library
 *
 */
function WebductCookieAdapter(cookieLibrary) {

    /**
     * @since 1.0.0
     *
     * @type {{path: string, domain: undefined, expires: undefined, secure: boolean}}
     */
    var options = {
        path: '/',
        domain: undefined,
        expires: undefined,
        secure: false
    };

    /**
     * Adapter for Cookies
     *
     * This object is returned.
     *
     * @since 1.0.0
     *
     * @type {Object}
     */
    var adapter = {};

    /**
     * Get Cookie
     *
     * @since 1.0.0
     *
     * @param {String} key
     * @returns {String}
     */
    adapter.getCookie = function(key) {
        var result;

        result = cookieLibrary.get(key);

        return result;
    };

    /**
     * Get options
     *
     * @since 1.0.0
     *
     * @returns {Object}
     */
    adapter.getOptions = function() {
        return options;
    };

    /**
     * Set Cookie
     *
     * @since 1.0.0
     *
     * @param {String} key
     * @param {Object} value
     * @returns {Boolean}
     */
    adapter.setCookie = function(key, value) {

        var result;

        // if successful the return value will be the Cookies object (??)
        result = cookieLibrary.set(key, value, options);
        result = result === cookieLibrary;

        return result;
    };

    /**
     * Expire Cookie
     *
     * @since 1.0.0
     *
     * @param {String} key
     * @param {Object} options
     *     Should only contain these fields:
     *     {
     *       path:
     *       domain:
     *     }
     * @returns {Boolean}
     */
    adapter.expireCookie = function(key, options) {

        var result;

        if (typeof options === 'undefined') {
            options = {
                path : '/',
                domain : '*'
            };
        }

        // if successful the return value will be the Cookies object (??)
        result = cookieLibrary.expire(key, options);  // Setting the cookie in the past will expire it
        result = result === cookieLibrary;

        return result;
    };

    /**
     * Set options
     *
     * @since 1.0.0
     *
     * @param {String} path
     * @param {String} domain
     * @param expires
     * @param {Boolean} secure
     */
    adapter.setOptions = function(path, domain, expires, secure) {
        options.path = path;
        options.domain = domain;
        options.expires = expires;
        options.secure = secure;
    };

    return adapter;
}
globalThis.WebductCookieAdapter = WebductCookieAdapter;
// EOF